export default __webpack_public_path__ + "static/media/giokibet_receipt.e1353775.jpg";